/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
/*
1 = 0.25rem = 4px

var spacing = {
  px: "1px",
  0.5: "0.125rem",
  1: "0.25rem",
  1.5: "0.375rem",
  2: "0.5rem",
  2.5: "0.625rem",
  3: "0.75rem",
  3.5: "0.875rem",
  4: "1rem",
  5: "1.25rem",
  6: "1.5rem",
  7: "1.75rem",
  8: "2rem",
  9: "2.25rem",
  10: "2.5rem",
  12: "3rem",
  14: "3.5rem",
  16: "4rem",
  20: "5rem",
  24: "6rem",
  28: "7rem",
  32: "8rem",
  36: "9rem",
  40: "10rem",
  44: "11rem",
  48: "12rem",
  52: "13rem",
  56: "14rem",
  60: "15rem",
  64: "16rem",
  72: "18rem",
  80: "20rem",
  96: "24rem"
};
*/
export default {
  0.25: '0.0625rem', // 1px
  0.5: '0.125rem', // 2px
  0.65: '0.1625rem', // 2.6px
  0.75: '0.1875rem', // 3px
  1: '0.25rem', // 4px
  1.25: '0.3125rem', // 5px
  1.5: '0.375rem', // 6px
  1.75: '0.4375rem', // 7px
  2: '0.5rem', // 8px
  2.25: '0.5625rem', // 9px
  2.375: '0.59375rem', // 9.5px
  2.5: '0.625rem', // 10px
  2.75: '0.6875rem', // 11px
  3: '0.75rem', // 12px
  3.25: '0.8125rem', // 13px
  3.5: '0.875rem', // 14px
  3.75: '0.9375rem', // 15px
  4: '1rem', // 16px
  4.25: '1.0625rem', // 17px
  4.5: '1.125rem', // 18px
  4.75: '1.1875rem', // 19px
  5: '1.25rem', // 20px
  5.25: '1.3125rem', // 21px
  5.5: '1.375rem', // 22px
  5.75: '1.4375rem', // 23px
  6: '1.5rem', // 24px
  6.25: '1.5625rem', // 25px
  6.5: '1.625rem', // 26px
  6.75: '1.6875rem', // 27px
  6.875: '1.71875rem', // 27.5px
  7: '1.75rem', // 28px
  7.25: '1.8125rem', // 29px
  7.5: '1.875rem', // 30px
  8: '2rem', // 32px
  8.5: '2.125rem', // 34px
  8.75: '2.1875rem', // 35px
  9: '2.25rem', // 36px
  9.5: '2.375rem', // 38px
  10: '2.5rem', // 40px
  10.25: '2.5625rem', // 41px
  11: '2.75rem', // 44px
  11.25: '2.8125rem', // 45px
  11.75: '2.9375rem', // 47px
  12: '3rem', // 48px
  12.5: '3.125rem', // 50px
  12.75: '3.1875rem', // 51px
  13: '3.25rem', // 52px
  13.5: '3.375rem', // 54px
  14: '3.5rem', // 56px
  15: '3.75rem', // 60px
  15.25: '3.8125rem', // 61px
  16: '4rem', // 64px
  17: '4.25rem', // 68px
  17.5: '4.375rem', // 70px
  18: '4.5rem', // 72px
  18.25: '4.5625rem', // 73px
  18.5: '4.625rem', // 74px
  19: '4.75rem', // 76px
  20: '5rem', // 80px
  25: '6.25rem', // 100px
  27.75: '6.9375rem', // 111px
  28: '7rem', // 112px
  29.25: '7.3125rem', // 117px
  30: '7.5rem', // 120px
  32: '8rem', // 128px
  35: '8.75rem', // 140px
  37: '9.25rem', // 148px
  37.5: '9.375rem', // 150px
  42: '10.5rem', // 168px
  50: '12.5rem', // 200px
};
